<div class="page-container asset-container container">
  <h1 class="header col-12"> {{ data.customTitle }} </h1>
  <div class="check-icon-container row col-12 mt-2">
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 53.74 42.21"
      style="enable-background: new 0 0 53.74 42.21"
      xml:space="preserve"
    >
      <path
        style="fill: #829c3c"
        d="M17.19 42.21 0 25.01l5.66-5.65 11.53 11.53L48.09 0l5.65 5.66z"
      />
    </svg>
  </div>
  <div class="row col-12 mt-2 justify-content-center">
    {{ data.customMessage }}
  </div>
</div>
